import { useQuery } from 'react-query';
import { useMiddleman } from '@hubins/middleman';

export const useDocuments = (types = [], profileUuid = '', portfolioUuid = '',) => {
  const middleman = useMiddleman();
  return useQuery(['documents', profileUuid, portfolioUuid, types], () => {
    return middleman.promiseGet(`/ql/crm/documents?type=${types.join(',')}${profileUuid ? `&profile=${profileUuid}` : ''}${portfolioUuid ? `&portfolio=${portfolioUuid}` : ''}`).then(res => res.data);
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};